var _rect, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1649,
    height: 1646,
    viewBox: "0 0 1649 1646",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2.5,
    width: 1640,
    height: 1640,
    stroke: "#E7E7E7",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 824.5,
    y1: -1.09278e-7,
    x2: 824.5,
    y2: 1645,
    stroke: "#E7E7E7",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 821.5,
    x2: 1646,
    y2: 821.5,
    stroke: "#E7E7E7",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2.35723,
    y1: 1643.36,
    x2: 1643.51,
    y2: 2.2027,
    stroke: "#E7E7E7",
    strokeWidth: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 5.89277,
    y1: 2.20269,
    x2: 1647.05,
    y2: 1643.36,
    stroke: "#E7E7E7",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.dae892724a4292c045f2bdf832d32c51.svg";
export { ForwardRef as ReactComponent };